import type { ContentHref } from '@generalTypes/apiTypes';
import type { RootState } from '@generalTypes/rootStateTypes';
import { selectValidationInfoForTocRow } from '@newStore/validation/validationSelectors';
import { useSelector } from 'react-redux';
import ValidationIndicator from './ValidationIndicator';

const ValidationIndicatorForToc: React.FC<{
  href: ContentHref;
  parentHref: ContentHref | undefined;
}> = ({ href, parentHref }) => {
  const validation = useSelector((state: RootState) =>
    selectValidationInfoForTocRow(state, href, parentHref),
  );

  if (!validation?.validationErrors?.length) {
    return null;
  }

  return (
    <ValidationIndicator
      href={href}
      status={validation.status}
      validationErrors={validation.validationErrors}
    />
  );
};

export default ValidationIndicatorForToc;
